// Profile accent colors. Owner-picked, stored as users/{uid}.profileAccent (a
// key, not a raw hex, so we control the palette and keep contrast in range on
// the dark theme). Applied on the public profile by overriding the --accent CSS
// variable. Selection in the UI never relies on color alone (always a label +
// a check), so it works for colorblind users.
export const ACCENTS = [
  { key: 'purple', label: 'Purple', hex: '#C084FC' }, // default (matches :root --accent)
  { key: 'blue',   label: 'Blue',   hex: '#5AA9FF' },
  { key: 'teal',   label: 'Teal',   hex: '#2DD4BF' },
  { key: 'green',  label: 'Green',  hex: '#4ADE80' },
  { key: 'amber',  label: 'Amber',  hex: '#FBBF24' },
  { key: 'coral',  label: 'Coral',  hex: '#FB7185' },
  { key: 'pink',   label: 'Pink',   hex: '#F472B6' },
];

export function accentHex(key) {
  return (ACCENTS.find(a => a.key === key) || ACCENTS[0]).hex;
}

// How loudly the chosen color shows on the public profile.
//   none ("Wallflower")    -> color isn't applied; clean default look
//   minimal ("Lowkey")     -> a few accents (buttons, badge rings, avatar initial)
//   max ("Main Character")  -> color everywhere (avatar ring, @handle, rank badges)
//                              plus a soft accent glow behind the profile header
export const ACCENT_LEVELS = [
  { key: 'none',    label: 'Wallflower',     desc: 'No color. Clean default look.' },
  { key: 'minimal', label: 'Lowkey',         desc: 'A subtle accent here and there.' },
  { key: 'max',     label: 'Main Character', desc: 'Your color everywhere, plus a header glow.' },
];

export const DEFAULT_ACCENT_LEVEL = 'minimal';

